
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 846 846","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M367.135 309.163a127.558 127.558 0 0 1 153.831 33.165","stroke":"#F6FBE5","stroke-width":"58.663"}}),_c('path',{attrs:{"d":"M562.928 372.132A149.418 149.418 0 0 1 477.845 563.1","stroke":"#94CC3F","stroke-width":"1.364","stroke-dasharray":"1.36 9.55"}}),_c('path',{attrs:{"d":"M683.135 181.177a358.117 358.117 0 0 1 88.461 175.441","stroke":"#F9CE62","stroke-width":"1.364"}}),_c('circle',{attrs:{"cx":"772.465","cy":"364.785","r":"7.503","transform":"rotate(-10.836 772.465 364.785)","stroke":"#F9CE62","stroke-width":"1.364"}}),_c('path',{attrs:{"d":"M310.357 447.652a115.257 115.257 0 0 1-.69-45.987 115.265 115.265 0 0 1 49.96-75.026 115.286 115.286 0 0 1 161.867 36.481 115.293 115.293 0 0 1 15.554 43.283","stroke":"#D1ED7E","stroke-width":"1.364","stroke-dasharray":"9.55 9.55"}})])
          )
        }
      }
    